const translations = {
  title: 'Locais',
  title_person: 'Pessoas',
  title_fleet: 'Frota',
  'menu.triggers': 'Automações',
  'menu.integrations': 'Integrações',
  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.levelsSettings': 'Customizar níveis',
  'menu.fieldsSettings': 'Customizar campos adicionais',
  'menu.templates': 'Templates de Documento',
  'menu.templateHistory': 'Histórico de Documento',
  'menu.qrcode': 'Gerador de QR Code',
  'menu.buckets': 'Histórico de lotes de QR Code',
  'menu.linktree': 'Customizar menu de QR Code',
  'menu.publicToken': 'Tokens públicos',
  'menu.placeType': 'Editar nome do tipo de local',
  'menu.placeLevelsEdit': 'Cadastro dos niveis',
  moreOptions: 'Mais opções',
  cardViewSoon: 'Visão de cards (em breve)',
  activated: 'Ativado',
  levels: 'Níveis',
  assets: 'Ativos',
  noQrcodeFound: 'Nenhum QR Code encontrado',
  'fields.NAME': 'Nome',
  'fields.INSERTED_AT': 'Data de criação',
  'fields.UPDATE_AT': 'Data de atualização',
  'guide.text':
    'Em locais, você criará todos os locais do seu cliente em que você fará seus atendimentos, externos ou internos. Os locais são baseados numa estrutura de cadastro de 4 níveis que podem ser customizados para melhor atender sua operação!',
  'guide.howToCreate': 'Como criar um local?',
  'guide.howToEdit': 'Como editar um local?',
  'guide.howToDelete': 'Como excluir um local?',
  'guide.howToEditLevels': 'Como editar os niveis dos locais?',
  'guide.howToEditFields': 'Como editar quais campos adicionais um place deve ter?',
  'guide.contact': 'Entre em contato e tire suas dúvidas'
}

export default translations
